import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=a9db5220&scoped=true"
import script from "./info-box.vue?vue&type=script&lang=js"
export * from "./info-box.vue?vue&type=script&lang=js"
import style0 from "./info-box.vue?vue&type=style&index=0&id=a9db5220&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a9db5220",
  null
  
)

export default component.exports